// Format helpers

export const toNum = (v) => {
  if (v === '' || v === null || v === undefined) return 0;
  const n = typeof v === 'number' ? v : parseFloat(String(v).replace(/,/g, ''));
  return isNaN(n) ? 0 : n;
};

export const fmtINR = (n, opts = {}) => {
  const num = toNum(n);
  if (opts.compact) {
    if (num >= 10000000) return `\u20B9 ${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `\u20B9 ${(num / 100000).toFixed(2)} L`;
    if (num >= 1000) return `\u20B9 ${(num / 1000).toFixed(1)} K`;
  }
  return `\u20B9 ${num.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
};

// PDF-safe currency formatter \u2014 react-pdf's default Helvetica font does not include
// the Indian Rupee glyph (U+20B9), which causes it to fall back to a boxy "1"-like
// character. Use plain "Rs." for anything rendered by @react-pdf/renderer.
export const fmtRs = (n, opts = {}) => {
  const num = toNum(n);
  if (opts.compact) {
    if (num >= 10000000) return `Rs. ${(num / 10000000).toFixed(2)} Cr`;
    if (num >= 100000) return `Rs. ${(num / 100000).toFixed(2)} L`;
    if (num >= 1000) return `Rs. ${(num / 1000).toFixed(1)} K`;
  }
  return `Rs. ${num.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`;
};

export const fmtDate = (d) => {
  if (!d) return '\u2014';
  const date = new Date(d);
  if (isNaN(date)) return d;
  return date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const daysUntil = (d) => {
  if (!d) return null;
  const date = new Date(d);
  const today = new Date();
  today.setHours(0,0,0,0);
  const diff = Math.round((date - today) / (1000 * 60 * 60 * 24));
  return diff;
};

export const scoreColor = (s) => {
  if (s >= 70) return { bg: 'bg-emerald-500', text: 'text-emerald-600', ring: 'ring-emerald-500', label: 'Strong', hex: '#10B981' };
  if (s >= 40) return { bg: 'bg-amber-500', text: 'text-amber-600', ring: 'ring-amber-500', label: 'Needs Attention', hex: '#EF9F27' };
  return { bg: 'bg-red-500', text: 'text-red-600', ring: 'ring-red-500', label: 'Critical', hex: '#E24B4A' };
};

export const scoreBand = (s) => {
  if (s >= 85) return 'Excellent';
  if (s >= 70) return 'Strong';
  if (s >= 55) return 'Good';
  if (s >= 40) return 'Fair';
  if (s >= 25) return 'Weak';
  return 'Critical';
};
